import { render } from "./RegisteredOwner.vue?vue&type=template&id=3689ce4d"
import script from "./RegisteredOwner.vue?vue&type=script&lang=js"
export * from "./RegisteredOwner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__